import React from 'react';

/**
 * Corner Fashdeck mark for users without an active paid plan.
 * Display overlay — generated files are also watermarked on the server.
 */
export default function FashdeckPlanWatermark({ show = false, compact = false }) {
  if (!show) return null;

  return (
    <div className="pointer-events-none absolute inset-0 z-[8]" aria-hidden>
      <div
        className={`absolute bottom-2 right-2 flex items-center gap-1.5 rounded-md bg-black/40 backdrop-blur-[2px] shadow-sm ${
          compact ? 'px-1.5 py-0.5' : 'px-2 py-1'
        }`}
      >
        <img
          src="/logo.png?v=20260711"
          alt=""
          className={compact ? 'h-3.5 w-3.5 object-contain' : 'h-5 w-5 object-contain'}
        />
        <span
          className={`font-semibold tracking-wide text-white drop-shadow ${
            compact ? 'text-[9px]' : 'text-[11px]'
          }`}
        >
          Fashdeck
        </span>
      </div>
    </div>
  );
}
